export default class Mask {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        if (value.match(/^[0-9]/)) {
            return '99999';
        }
        else {
            //With '*' instead of 'a' else is always applied.
            return '*a-99999';
        }
    }

    birthdate() {
        return '2999-19-39';
    }
}
